/**
 * Vertaalt een aangetikte clubcoachapp.nl-link naar een route binnen de app.
 *
 * De native app draait op capacitor://localhost en niet op de website, dus een
 * universal link komt binnen als een volledige https-URL die nergens heen wijst.
 * Alleen het pad is bruikbaar: dat kent de router wél, want de spelerspagina heeft
 * op web en in de app dezelfde route.
 *
 * iOS levert hier uitsluitend URL's af die het al tegen het AASA-bestand heeft
 * gecontroleerd (public/.well-known/apple-app-site-association). De controle
 * hieronder is dus een tweede slot en niet het eerste: hij houdt de app op zijn
 * plek als er ooit een link uit een andere hoek binnenkomt.
 */

const EIGEN_DOMEIN = 'clubcoachapp.nl';

/** Test- en productiedomein delen dezelfde app-bundel en dus dezelfde routes. */
function isEigenDomein(hostname: string): boolean {
  return hostname === EIGEN_DOMEIN || hostname.endsWith(`.${EIGEN_DOMEIN}`);
}

/**
 * Geeft het pad om naartoe te navigeren, of null als de link niet van ons is of
 * naar een pagina wijst die de app niet zelf toont. Bij null hoort de app niets te
 * doen: iOS heeft de link dan al aan Safari gegeven of geeft hem daar alsnog aan.
 */
export function routeUitDeepLink(url: string): string | null {
  let ontleed: URL;
  try {
    ontleed = new URL(url);
  } catch {
    return null;
  }

  if (ontleed.protocol !== 'https:' || !isEigenDomein(ontleed.hostname)) {
    return null;
  }

  // Alleen de publieke spelerspagina, gelijk aan wat het AASA-bestand toestaat.
  // /team is zonder team-id een halve link en hoort dus niet mee te tellen.
  if (!ontleed.pathname.startsWith('/team/') || ontleed.pathname === '/team/') {
    return null;
  }

  return `${ontleed.pathname}${ontleed.search}${ontleed.hash}`;
}
